export const AdSetTurnedOnIcon = ({ className, size = 27, ...props }) => (
    <svg
        {...props}
        width={size}
        height={size}
        viewBox="0 0 27 27"
        fill="none"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
    >
        <mask id="path-3-inside-1_5868_51599" fill="white">
            <rect x="0.333984" y="6.33398" width="5.92593" height="5.92593" rx="0.888889" />
        </mask>
        <rect
            x="0.333984"
            y="6.33398"
            width="5.92593"
            height="5.92593"
            rx="0.888889"
            stroke="#4DD15E"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            mask="url(#path-3-inside-1_5868_51599)"
        />
        <mask id="path-4-inside-2_5868_51599" fill="white">
            <rect x="7.74023" y="6.33398" width="5.92593" height="5.92593" rx="0.888889" />
        </mask>
        <rect
            x="7.74023"
            y="6.33398"
            width="5.92593"
            height="5.92593"
            rx="0.888889"
            stroke="#4DD15E"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            mask="url(#path-4-inside-2_5868_51599)"
        />
        <mask id="path-5-inside-3_5868_51599" fill="white">
            <rect x="7.74023" y="13.7402" width="5.92593" height="5.92593" rx="0.888889" />
        </mask>
        <rect
            x="7.74023"
            y="13.7402"
            width="5.92593"
            height="5.92593"
            rx="0.888889"
            stroke="#4DD15E"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            mask="url(#path-5-inside-3_5868_51599)"
        />
        <mask id="path-6-inside-4_5868_51599" fill="white">
            <rect x="0.333984" y="13.7402" width="5.92593" height="5.92593" rx="0.888889" />
        </mask>
        <rect
            x="0.333984"
            y="13.7402"
            width="5.92593"
            height="5.92593"
            rx="0.888889"
            stroke="#4DD15E"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            mask="url(#path-6-inside-4_5868_51599)"
        />
        <path
            d="M21.6095 4.41832L17.2428 2.10594C16.7054 1.81869 16 2.14905 16 2.6948V7.3052C16 7.851 16.6886 8.1813 17.2428 7.89405L21.6095 5.58167C22.1302 5.32312 22.1302 4.69122 21.6095 4.41832Z"
            stroke="#4DD15E"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

export default AdSetTurnedOnIcon
